// Application Configuration
// Hardcoded for Cloudflare Pages deployment

export const config = {
  // API Configuration
  apiUrl: 'https://ai.riko.my',
  
  // App Configuration
  appName: 'Flazu API Dashboard',
  appVersion: '1.0.0',
  
  // Company Info
  company: {
    name: 'Flazu API',
    owner: 'ChuyoRiko',
    email: 'chuyo@riko.my',
    domain: 'riko.my',
  },
  
  // Contact Emails
  emails: {
    support: 'chuyo@riko.my',
    dmca: 'chuyo@riko.my',
    legal: 'chuyo@riko.my',
    privacy: 'chuyo@riko.my',
    abuse: 'chuyo@riko.my',
  },
  
  // Features
  features: {
    enableDevTools: false, // Set to true for development
    enableProtection: true,
  },
};

export default config;
